export enum SaveState {
  CLEAN = 'clean',
  DIRTY = 'dirty',
  SAVING = 'saving',
  SAVED = 'saved',
}
